export default __webpack_public_path__ + "static/media/6.15a9904e.png";